import { useQuery } from '@tanstack/react-query';

import { listPatientDeliveryAddresses } from '../../../api/patient-delivery-addresses';
import { useAuth } from '../../auth/AuthProvider';

export function usePatientDeliveryAddresses(patientId: string) {
  const { tokens } = useAuth();
  const token = tokens?.access_token;

  return useQuery({
    queryKey: ['patientDeliveryAddresses', patientId],
    queryFn: async () => {
      if (!token) {
        throw new Error('Authenticated admin session is required.');
      }
      return listPatientDeliveryAddresses(patientId, token);
    },
    enabled: Boolean(patientId && token),
  });
}
